export default 'https://tme.understood.org/assets/smoke.b1e09d6e.glb'